import React from "react";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";

const Leadership = ({ heading }) => {
  return (
    <div
      id="leadership"
      className="jumbotron jumbotron-fluid m-0"
      style={{
        backgroundColor: "#f8f9fa",
        paddingTop: "0px",
        paddingBottom: "0px",
      }}
    >
      <div className="container container-fluid">
        <h2 className="display-4 pb-5 text-center">{heading}</h2>
        <div className="row">
          <div className="col-md-12">
            <div className="timeline-centered">
              <Timeline lineColor={"#ddd"} animate={true}>
              <TimelineItem
                  key="001"
                  dateText="04/2023 - Present"
                  dateInnerStyle={{ background: "#76bb7f" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>SEDUC-PI (GTI - Gerência de Tecnologia da Informação)</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Software developer</h4>
                  <p>
                  I work in creating applications using JavaScript technologies 
                  (Node.js, Angular), with a focus on SQL query optimization. 
                  </p>
                  <p>
                  My work has led to an average reduction of 30% in response time.
                  </p>
                  <p>
                  Additionally, I contributed to the implementation and analysis of 
                  API integrations and new modules in the ISeduc application, enhancing 
                  scalability and delivering higher-quality solutions.
                  </p>
                </TimelineItem>

                <TimelineItem
                  key="002"
                  dateText="03/2023 - Present"
                  dateInnerStyle={{ background: "#76bb7f" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>Intraversa</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Software developer</h4>
                  <p>
                  Worked part-time on projects involving technologies such as 
                  AngularJS and React Native with Expo.
                  </p>
                  <p>
                  Notably, I led the "Servicefy" project, which involved migrating 
                  an Ionic app to React Native with Expo. This migration led to 
                  increased portability and modernized interfaces.
                  </p>
                  <p>
                  I was responsible for both the analysis and construction of the 
                  entire new application architecture.
                  </p>
                </TimelineItem>

                <TimelineItem
                  key="003"
                  dateText="07/2021 - Present"
                  dateInnerStyle={{ background: "#76bb7f" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>DevMagic</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Software developer</h4>
                  <p>
                  As a Full Stack Developer at Devmagic, I am responsible 
                  for ensuring the security, optimization, and availability 
                  of scalable stream systems. 
                  </p>
                  <p>
                  In addition, I configure and consume AWS services for the 
                  company's main projects, using technologies such as Node.js, 
                  Angular.Js and React.js. 
                  </p>
                  <p>
                  I have experience working with PostgreSQL and Redis DB databases, 
                  and use my technical skills and leadership ability to help the 
                  company achieve its goals.
                  </p>
                </TimelineItem>

                <TimelineItem
                  key="005"
                  dateText="01/2021 – 01/2023"
                  dateInnerStyle={{ background: "#61b8ff" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>Elliptic Technology</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Technical Leader and Partner</h4>
                  <p>
                  Responsible for full-stack application development and infrastructure using 
                  Node.js and ReactJS, managing both relational and non-relational databases, 
                  gathering software requirements, training new team members, version control, 
                  code quality assurance, continuous integration, AWS service deployment, 
                  and software testing using Jest.js.
                  </p>
                </TimelineItem>
                
                <TimelineItem
                  key="006"
                  dateText="11/2020 – 08/2021"
                  dateInnerStyle={{ background: "#61b8ff" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>TRE-Pi</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Business Intelligence Intern</h4>
                  <p>
                  As a Business Intelligence Intern, I had the opportunity to acquire 
                  valuable knowledge in data analysis and related technologies during 
                  my experience at the company.
                  </p>
                  <p>
                  I performed analysis, extraction, treatment, and display of information, 
                  created impactful panels and delivered high-quality reports. In addition, 
                  I had experience in assisting and developing web pages with HTML, CSS, 
                  and JavaScript.
                  </p>
                  <p>
                  This internship was a valuable opportunity for my professional growth, as 
                  it allowed me to acquire valuable skills and knowledge that will be fundamental 
                  in my career.
                  </p>
                </TimelineItem>
                
                <TimelineItem
                  key="007"
                  dateText="11/2018 – 10/2019"
                  dateInnerStyle={{ background: "#61b8ff" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>Universidade Federal do Piauí</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Information Technology Infrastructure Fellow</h4>
                  <p>
                  As a scholarship student at the Federal University of Piauí (UFPI), 
                  I gained extensive experience in computer network administration.
                  </p>
                  <p>
                  I performed a wide range of tasks including installation and configuration 
                  of digital communication devices, conducting network diagnostics, troubleshooting, 
                  preparing and installing cabling, configuring user access, configuring firewalls 
                  and servers, programming security resources, installing and configuring switches, 
                  access points and routers, configuring VLANs, VPNs, and servers, creating detailed 
                  technical reports, conducting on-site technical visits, and utilizing tools such as 
                  Zabbix, IpUfpi, Redmines, and Cisco's Deepspace. 
                  </p>
                  <p>
                  Additionally, I developed my skills in creating JavaScript scripts for automating 
                  internal tasks.
                  </p>
                </TimelineItem>   

                <TimelineItem
                  key="008"
                  dateText="08/2017 – 11/2018"
                  dateInnerStyle={{ background: "#61b8ff" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>Universidade Federal do Piauí</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>Technical Support Fellow</h4>
                  <p>
                  Acting in all sectors of CNN and administrative UFPI, performing technical support 
                  in software and hardware, whether for internal and external customers, setting up 
                  email, installing, configuring and updating Linux, Windows and MacOS operating systems, 
                  installs and performs maintenance of digital communication, installs and maintains 
                  printers, installs a database, creates backup copies, prepares technical reports 
                  and provides customer service.
                  </p>
                </TimelineItem>

                <TimelineItem
                  key="009"
                  dateText="09/2015 – 11/2015"
                  dateInnerStyle={{ background: "#61b8ff" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{ marginBottom: "6px" }}>Pronatec</h3>
                  <h4 style={{ marginBottom: "6px", color: "#61b8ff" }}>IT Intern</h4>
                  <p>
                  As a Technical Support Intern, I was responsible for performing maintenance on computers, 
                  organizing school data, typing tests and preparing reports. I also served the user, ensuring 
                  the proper functioning of systems and solving technical problems. 
                  </p>                  
                  <p>
                  During this internship, I acquired important skills in customer service and problem solving, 
                  as well as learning about information technology in a practical way.
                  </p>
                </TimelineItem>
              </Timeline>
            </div>
          </div>
        </div>
      </div>      
      
      <div className="container container-fluid">
        <h2 className="display-4 pb-5 text-center">Volunteer work</h2>
        <div className="row">
          <div className="col-md-12">
            <div className="timeline-centered">
              <Timeline lineColor={"#ddd"} animate={true}>
                <TimelineItem
                  key="001"
                  dateText="07/2020 – 10/2021"
                  dateInnerStyle={{ background: "#61b8ff" }}
                  bodyContainerStyle={{
                    background: "#fff",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <h3 style={{marginBottom: "6px"}}>Academic Entrepreneurship and Financial Market League of UFPI</h3>
                  <h4 style={{marginBottom: "6px", color: "#61b8ff" }}>Full Stack Developer</h4>
                  <p>
                  As a developer, I am experienced in building robust and scalable 
                  Restful APIs using Node.js and Docker technology.
                  </p>
                  <p>
                  I have a strong understanding of both relational databases such 
                  as MySql and Postgresql, as well as non-relational databases like 
                  Redis DB and Mongo DB.
                  </p>
                  <p>
                  I am responsible for gathering software requirements and training 
                  new team members. I have a good knowledge of software version control 
                  using Git and Github, and I am familiar with continuous integration 
                  using Github Actions.
                  </p>                  
                  <p>
                  I am well-versed in deploying services on various platforms such as 
                  KingHost and Heroku. I use Jest.js for software testing. Additionally, 
                  I provide support in web development tasks such as creating semantic HTML, 
                  CSS, and building interactive web pages using React.js, Axios, React Hooks, 
                  Flexbox and CSS grid.
                  </p>
                </TimelineItem>
              </Timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leadership;
